module.exports = __webpack_public_path__ + "static/img/icon-push-failed.6e7cf31.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon-push-failed.svg
// module id = dpXF
// module chunks = 134